import React, { useState } from "react";
import { FileTextOutlined } from "@ant-design/icons";
import { Badge, Button, Card, Col, DatePicker, Layout, Menu, Modal, Row, Typography, Splitter } from "antd";
import PdfViewer from "../../../components/pageComponents/PdfViewer";

const { Meta } = Card;
const { Title, Text } = Typography;
const notesCardDetail = [
  { title: "Introduction to HTML Basics", date: "2025-01-15", isNew: true },
  { title: "CSS Grid and Flexbox Explained", date: "2025-01-14" },
  { title: "JavaScript ES6 Features Overview", date: "2025-01-13" },
  { title: "Responsive Design with Tailwind CSS", date: "2025-01-12", isNew: true },
  { title: "Understanding React Components", date: "2025-01-11" },
  { title: "State Management in React", date: "2025-01-10" },
  { title: "Building a RESTful API with Node.js", date: "2025-01-09", isNew: true },
  { title: "Intro to Framer Motion for Animations", date: "2025-01-08" },
  { title: "Accessibility in Web Development", date: "2025-01-07" },
  { title: "Optimizing Web Performance", date: "2025-01-06" },
];

const Notes = () => {
  const [searchDate, setSearchDate] = useState(null);

  const handleDateChange = (date, dateString) => {
    setSearchDate(dateString);
  };

  const filteredNotes = searchDate
    ? notesCardDetail.filter((note) => note.date === searchDate)
    : notesCardDetail;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <Title level={4}>Notes</Title>
        <DatePicker
          placeholder="Search by date"
          onChange={handleDateChange}
          format="YYYY-MM-DD"
          style={{ width: 200 }}
        />
      </div>

      {filteredNotes.length > 0 ? (
        <Row gutter={[16, 16]}>
          {filteredNotes.map((note, index) => (
            <Col key={index} xs={24} sm={12} lg={8}>
              <NotesCard
                title={note.title}
                date={note.date}
                isNew={note.isNew}
                pdfUrl={`https://example.com/pdf/${note.title.replace(/\s+/g, "_")}.pdf`}
                allNotes={filteredNotes}
              />
            </Col>
          ))}
        </Row>
      ) : (
        <Text>No notes found for the selected date.</Text>
      )}
    </div>
  );
};

export default Notes;

const NotesCard = ({ title, date, isNew, pdfUrl, allNotes }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(pdfUrl);

  const showModal = () => setIsModalVisible(true);
  const handleCancel = () => setIsModalVisible(false);

  const handleMenuClick = (e) => {
    const selectedNote = allNotes.find((note) => note.title === e.key);
    if (selectedNote) {
      setSelectedPdf(`https://example.com/pdf/${selectedNote.title.replace(/\s+/g, "_")}.pdf`);
    }
  };

  return (
    <Badge.Ribbon text={isNew ? "New" : "HTML"} color="blue">
      <Card className="relative" hoverable>
        <Meta title={title} description={`Date: ${date}`} />
        <Button
          type="primary"
          icon={<FileTextOutlined />}
          onClick={showModal}
          className="mt-4"
          block
        >
          View PDF
        </Button>
        <Modal
          title={`Viewing Notes`}
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={null}
          width="90%"
        >
          <Splitter
            style={{
              height: "400px",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Sidebar */}
            <Splitter.Panel defaultSize="30%" min="20%" max="50%">
              <Menu
                mode="inline"
                defaultSelectedKeys={[title]}
                onClick={handleMenuClick}
                style={{
                  height: "100%",
                  borderRight: "1px solid #ddd",
                }}
              >
                {allNotes.map((note) => (
                  <Menu.Item key={note.title} icon={<FileTextOutlined />}>
                    {note.title}
                  </Menu.Item>
                ))}
              </Menu>
            </Splitter.Panel>

            {/* Content */}
            <Splitter.Panel>
              <div style={{ padding: "16px", height: "100%", overflow: "auto" }}>
                <PdfViewer url={selectedPdf} />
              </div>
            </Splitter.Panel>
          </Splitter>
        </Modal>
      </Card>
    </Badge.Ribbon>
  );
};
